// Titles only — the legal texts live in the lazy-loaded LegalPage chunk (see index.js).
export const LEGAL_SLUGS = ['privacy-policy', 'cookie-policy', 'terms', 'imprint'];

export const LEGAL_TITLES = {
  en: {
    'privacy-policy': 'Privacy Policy',
    'cookie-policy': 'Cookie Policy',
    terms: 'Terms & Conditions and Cancellation Policy',
    imprint: 'Imprint / Company Details'
  },
  me: {
    'privacy-policy': 'Politika privatnosti',
    'cookie-policy': 'Politika kolačića',
    terms: 'Uslovi korišćenja i politika otkazivanja',
    imprint: 'Impresum / Podaci o firmi'
  },
  sq: {
    'privacy-policy': 'Politika e privatësisë',
    'cookie-policy': 'Politika e cookies',
    terms: 'Kushtet e përgjithshme dhe politika e anulimit',
    imprint: 'Impressum / Të dhënat e kompanisë'
  },
  de: {
    'privacy-policy': 'Datenschutzerklärung',
    'cookie-policy': 'Cookie-Richtlinie',
    terms: 'AGB und Stornierungsbedingungen',
    imprint: 'Impressum'
  },
  pl: {
    'privacy-policy': 'Polityka prywatności',
    'cookie-policy': 'Polityka cookies',
    terms: 'Regulamin i polityka anulowania',
    imprint: 'Impressum / Dane firmy'
  },
  ru: {
    'privacy-policy': 'Политика конфиденциальности',
    'cookie-policy': 'Политика cookies',
    terms: 'Условия бронирования и политика отмены',
    imprint: 'Выходные данные / Данные компании'
  },
  hu: {
    'privacy-policy': 'Adatvédelmi tájékoztató',
    'cookie-policy': 'Süti (cookie) tájékoztató',
    terms: 'Általános szerződési és lemondási feltételek',
    imprint: 'Impresszum / Cégadatok'
  },
  ro: {
    'privacy-policy': 'Politica de confidențialitate',
    'cookie-policy': 'Politica de cookie-uri',
    terms: 'Termeni și condiții și politica de anulare',
    imprint: 'Date de identificare / Datele companiei'
  }
};

export const legalTitle = (lang, slug) => (LEGAL_TITLES[lang] || LEGAL_TITLES.en)[slug];
